if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const hero_overlay =
          video_background_section.querySelector(".hero__overlay");
        if (!hero_overlay) return;
        if (!video_background_section.querySelector("video")) return;

        this.hero_overlay = hero_overlay;
        this.playHandler = (event) => {
          if (this.isControlTarget(event)) return;
          this.playVideo(this.visibleVideo(video_background_section));
        };

        hero_overlay.addEventListener("touchstart", this.playHandler);
        hero_overlay.addEventListener("click", this.playHandler);
      }

      checkAndPlayVideoSection(video) {
        if (!video.querySelector("video")) return;

        this.playHandler = (event) => {
          if (this.isControlTarget(event)) return;
          this.playVideo(this.visibleVideo(video));
        };

        video.addEventListener("touchstart", this.playHandler);
        video.addEventListener("click", this.playHandler);
      }

      // On touch devices a tap fires touchstart AND click. Without this guard the
      // touchstart plays the video, then the control's own click handler sees a
      // playing video and pauses it again, so the tap looks like it did nothing.
      // Explicit play/pause controls own their toggle; only kickstart elsewhere.
      isControlTarget(event) {
        const target = event && event.target;
        if (!target || !target.closest) return false;
        return !!target.closest(
          "video-controls, [data-inline-play-button], button, a",
        );
      }

      // Desktop and mobile videos can both be present; the hidden one is
      // display:none. Resolve the visible one at event time, not at bind time.
      visibleVideo(scope) {
        const videos = scope.querySelectorAll("video");
        for (const video of videos) {
          if (video.offsetParent !== null || video.getClientRects().length) {
            return video;
          }
        }
        return videos[0] || null;
      }

      playVideo(video_element) {
        if (!video_element) return;
        if (video_element.paused || video_element.ended) {
          const played = video_element.play();
          if (played && played.catch) played.catch(() => {});
        }
      }

      disconnectedCallback() {
        if (!this.playHandler) return;

        const target = this.video_section || this.hero_overlay;
        if (!target) return;

        target.removeEventListener("touchstart", this.playHandler);
        target.removeEventListener("click", this.playHandler);
      }
    },
  );
}
